import React from 'react'
import { Container } from 'reactstrap'
import { RootState } from './redux/store'

export const ErrorView: React.FC<{
    message: string
    stack?: string
    state?: RootState
}> = (props) => {

    return (
        <Container
            className="vh-100 d-flex flex-column justify-content-center"
        >
            <div className="mb-5 text-center">
                <h4 className="text-danger">{"An error has occurred!"}</h4>
                <p className="mb-0">
                    {"Try reloading the page."}

                    {/* <br />
                    {"If the error keeps happening, try getting the information"}
                    {" below to a developer."} */}
                </p>
            </div>

            <div className="mt-4 mb-2 d-flex">
                <div className="font-weight-bold small text-muted mr-2">
                    {"Error message"}
                </div>
            </div>
            <pre
                style={{
                    maxHeight: "200px",
                    userSelect: "all"
                }}
                className="border p-3 shadow-sm"
            >
                {props.message}
            </pre>

            {props.stack != null && props.stack !== "" &&
                <>
                    <div className="mt-4 mb-2 d-flex">
                        <div className="font-weight-bold small text-muted mr-2">
                            {"Stacktrace"}
                        </div>
                        <div className="font-italic small text-muted">
                            {"(this bit is most important)"}
                        </div>
                    </div>
                    <pre
                        style={{
                            maxHeight: "200px",
                            userSelect: "all"
                        }}
                        className="border p-3 shadow-sm"
                    >
                        {props.stack}
                    </pre>
                </>
            }

            {props.state != null &&
                <>
                    <div className="mb-2 mt-2 d-flex">
                        <div className="font-weight-bold small text-muted mr-2">
                            {"Application state"}
                        </div>
                        <div className="font-italic small text-danger">
                            {"(don't share this if you want to keep your setups private)"}
                        </div>
                    </div>
                    <pre
                        style={{
                            maxHeight: "200px",
                            userSelect: "all"
                        }}
                        className="border p-3 shadow-sm"
                    >
                        {JSON.stringify(props.state, null)}
                    </pre>
                </>
            }
        </Container>
    )
}
